export const InvitationStatus = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  PENDING: 'PENDING',
  UNKNOWN: 'UNKNOWN',
};
